import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';

// Varsayılan marker ikonunu düzeltmek için
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

// Harita görünümünü dinamik olarak güncellemek için yardımcı bileşen
function ChangeView({ center }) {
    const map = useMap();
    useEffect(() => {
        if (center) {
            map.setView(center, map.getZoom());
        }
    }, [center, map]);
    return null;
}

function LocationPickerMap({ initialLatitude, initialLongitude, onLocationChange }) {
    const defaultPosition = [39.9334, 32.8597]; // Ankara
    const [position, setPosition] = useState(
        initialLatitude && initialLongitude
            ? [initialLatitude, initialLongitude]
            : defaultPosition
    );

    // İlk açılışta eğer koordinat yoksa kullanıcının konumunu bul
    useEffect(() => {
        if (!initialLatitude && !initialLongitude) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (pos) => {
                        const { latitude, longitude } = pos.coords;
                        const newPos = [latitude, longitude];
                        setPosition(newPos);
                        onLocationChange(latitude, longitude);
                    },
                    (error) => {
                        console.warn("Geolocation error:", error);
                    },
                    { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
                );
            }
        }
    }, []);

    function MapClickHandler() {
        useMapEvents({
            click(e) {
                setPosition([e.latlng.lat, e.latlng.lng]);
                onLocationChange(e.latlng.lat, e.latlng.lng);
            },
        });
        return null;
    }

    useEffect(() => {
        if (initialLatitude && initialLongitude) {
            setPosition([initialLatitude, initialLongitude]);
        }
    }, [initialLatitude, initialLongitude]);

    return (
        <MapContainer
            center={position}
            zoom={13}
            scrollWheelZoom={true}
            style={{ height: '400px', width: '100%' }}
        >
            <ChangeView center={position} />
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {position && (
                <Marker
                    position={position}
                    draggable={true}
                    eventHandlers={{
                        dragend: (e) => {
                            const newLat = e.target.getLatLng().lat;
                            const newLng = e.target.getLatLng().lng;
                            setPosition([newLat, newLng]);
                            onLocationChange(newLat, newLng);
                        },
                    }}
                />
            )}
            <MapClickHandler />
        </MapContainer>
    );
}

export default LocationPickerMap;
